import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-all duration-200 ease-out focus:outline-none",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-blue-50 text-blue-700",
        secondary:
          "border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50",
        destructive:
          "border-transparent bg-red-50 text-red-700",
        outline: "border-zinc-200 text-zinc-700 bg-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
